<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Assign Permission to Role
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0">

<mat-dialog-content>
    <table class="table editTable">
        <tr>
            <td colspan="2" class="px-3">
                Roles
            </td>
        </tr>
        <tr>
            <td colspan="2" class="px-3">
                <mat-form-field class="w-full">
                    <input matInput [(ngModel)]="rolesData.role" disabled>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td colspan="2" class="px-3">
                Permission
            </td>
        </tr>
        <tr>
            <td colspan="2" class="px-3">
                <mat-form-field class="w-full">
                    <mat-select multiple [(ngModel)]="selectedPermission">
                        <mat-option *ngFor="let permission of permissions" [value]="permission"> {{ permission }} </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>
    </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>Cancel</button>
    <button class="btn btn-primary" [disabled]="isPermissionChange() || isLoading " (click)="updateRole()">
        <span *ngIf="isLoading" class="loading loading-ring loading-sm"></span>
        {{ isLoading ? 'Updating...': 'Update' }}</button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>